import { render } from "./BrideGroomSection.vue?vue&type=template&id=54cdf8c8&scoped=true"
import script from "./BrideGroomSection.vue?vue&type=script&lang=js"
export * from "./BrideGroomSection.vue?vue&type=script&lang=js"

import "./BrideGroomSection.vue?vue&type=style&index=0&id=54cdf8c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cdf8c8"]])

export default __exports__